export const SwapDownIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="var(--swapper-primary-color)" />
      <path
        d="M6 14L7.45 12.6L11 16.15V4H13V16.15L16.55 12.6L18 14L12 20L6 14Z"
        fill="white"
      />
    </svg>
  );
};
